import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { MarqueeListResponse } from '@magnetar/admin-api-interfaces'

interface UseMarqueesOptions {
  broadcast_device_id: number | string
}

export function useMarqueesByDeviceId({ broadcast_device_id }: UseMarqueesOptions) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<MarqueeListResponse>(
    token ? `/api/broadcast-device/${broadcast_device_id}/marquees` : null,
    undefined,
    token ?? '',
    undefined,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
    },
  )

  return {
    marquees: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
